export enum Language {
  DUTCH = 'nl',
  ENGLISH = 'en',
}
